import { render } from "./LimitOrders.vue?vue&type=template&id=495e5d65&scoped=true"
import script from "./LimitOrders.vue?vue&type=script&lang=js"
export * from "./LimitOrders.vue?vue&type=script&lang=js"

import "./LimitOrders.vue?vue&type=style&index=0&id=495e5d65&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495e5d65"],['__file',"resources/js/components/LimitOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "495e5d65"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('495e5d65', __exports__)) {
    api.reload('495e5d65', __exports__)
  }
  
  module.hot.accept("./LimitOrders.vue?vue&type=template&id=495e5d65&scoped=true", () => {
    api.rerender('495e5d65', render)
  })

}


export default __exports__